import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import SuccessModal from '../../../features/components/Modals/SuccessModal'

import { getSelectedPlatform } from '../../../helpers/handlePlatformSelection'
import { getAdStructureType } from '../helpers'

import { openForm } from '../../../modules/actions/forms'

import { MODAL_TYPE } from '../../../constants/other'
import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../constants/selectLists/platformList'
import { AD_DV360_CREATE, AD_FACEBOOK_CREATE, AD_GOOGLE_CREATE, AD_TIKTOK_CREATE } from '../../../constants/forms'

const NewLineItemCreatedModal = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const selectedPlatform = getSelectedPlatform()

  const lineItemCreatedMessage = (
    <>
      <p>{t(`Your ${getAdStructureType(selectedPlatform).toLowerCase()} was created successfully.`)}</p>
      <p>
        {t(
          'The next step is to create an ad. We recommend creating around 3 significantly different ads (if possible) for best results.'
        )}
      </p>
    </>
  )

  const openAdFacebookCreateForm = useCallback(() => {
    dispatch(openForm({ formName: AD_FACEBOOK_CREATE }))
  }, [dispatch])

  const openAdGoogleCreateForm = useCallback(() => {
    dispatch(openForm({ formName: AD_GOOGLE_CREATE }))
  }, [dispatch])

  const openAdTikTokCreateForm = useCallback(() => {
    dispatch(openForm({ formName: AD_TIKTOK_CREATE }))
  }, [dispatch])

  const openAdDv360CreateForm = useCallback(() => {
    dispatch(openForm({ formName: AD_DV360_CREATE }))
  }, [dispatch])

  const openFormHandler = useMemo(() => {
    switch (selectedPlatform) {
      case FACEBOOK_PLATFORM:
        return openAdFacebookCreateForm
      case GOOGLE_PLATFORM:
        return openAdGoogleCreateForm
      case TIKTOK_PLATFORM:
        return openAdTikTokCreateForm
      case DV_360_PLATFORM:
        return openAdDv360CreateForm
      default:
        return () => {}
    }
  }, [
    selectedPlatform,
    openAdFacebookCreateForm,
    openAdGoogleCreateForm,
    openAdTikTokCreateForm,
    openAdDv360CreateForm
  ])

  return (
    <SuccessModal
      successButtonText={t('Create Ad')}
      successButtonAction={openFormHandler}
      modalType={MODAL_TYPE.newLineItemCreated}
    >
      {lineItemCreatedMessage}
    </SuccessModal>
  )
}

export default NewLineItemCreatedModal
